import React from "react";
import { Alert } from "@material-ui/lab";
import PageSpinner from "../../elements/spinner/PageSpinner";
import { Trans, useTranslation } from "react-i18next";

import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../styles/styledTable";
import { StyledBreakWord } from "../../styles/styledBreakWord";
import MaterialSwitch from "../../styles/materialSwitch";

const WalletWhitelistList = ({
  walletMainWhitelist,
  setOpenDelete,
  deleteSubmitData,
  setDeleteSubmitData,
  setOpenActivity,
  activitySubmitData,
  setActivitySubmitData
}) => {
  const { t } = useTranslation("walletWhitelistPage");

  if (!walletMainWhitelist) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (walletMainWhitelist.length === 0) {
    return <Alert severity="warning">{t("table.emptyData")}</Alert>;
  }

  return (

    <StyledScrollTable className="wallet-whitelist_scroll">
      <StyledTable
        width="992"
        size="14"
        className="wallet-whitelist"
      >
        <StyledTableHead
          className="wallet-whitelist__head"
          scroll="auto"
          col="6"
        >
          <div className="wallet-whitelist__col blockchain-url_col-fixed">
            {t("table.activity")}
          </div>
          <div className="wallet-whitelist__col blockchain-url_col-fixed">
            {t("table.currency")}
          </div>
          <div className="wallet-whitelist__col">
            {t("table.paymentSystem")}
          </div>
          <div className="wallet-whitelist__col">
            {t("table.wallet")}
          </div>
          <div className="wallet-whitelist__col">
            {t("table.tag")}
          </div>
          <div className="wallet-whitelist__col">
            {t("table.action")}
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {walletMainWhitelist && walletMainWhitelist.map((item, key) => (
            <StyledTableRow
              className="wallet-whitelist__row"
              key={key}
              scroll="auto"
              col="5"
            >
              <StyledCol
                data-title={t("table.activity")}
                className="wallet-whitelist__col blockchain-url_col-fixed"
              >
                <MaterialSwitch
                  checked={item.isActive}
                  onChange={() => {
                    setActivitySubmitData({
                      ...activitySubmitData,
                      id: item.id,
                      isActive: !item.isActive
                    });
                    setOpenActivity(true);
                  }}
                  label={t("details.changeForm.active")}
                />
              </StyledCol>
              <StyledCol
                data-title={t("table.currency")}
                className="wallet-whitelist__col blockchain-url_col-fixed"
              >
                {item.currency}
              </StyledCol>
              <StyledCol
                data-title={t("table.paymentSystem")}
              >
                {item.paymentSystem}
              </StyledCol>
              <StyledCol
                inline
                data-title={t("table.wallet")}
                className="wallet-whitelist__col"
              >
                {!item.isApproved ? (
                  <Alert severity="info">
                    <Trans
                      i18nKey="table.waitingApproveForUser"
                      t={t}
                      values={{ wallet: item.wallet }}
                      components={{ span: <StyledBreakWord as="p" /> }}
                    />
                  </Alert>
                ) : (
                  <StyledBreakWord as="p">{item.wallet}</StyledBreakWord>
                )}
              </StyledCol>
              <StyledCol data-title={t("table.tag")}>
                {item.tag ?? "--"}
              </StyledCol>
              <StyledCol
                inline
                data-title={t("table.action")}
                className="wallet-whitelist__col"
              >
                <div className="wallet-whitelist__actions">
                  <button
                    className="table-action table-action_info"
                    onClick={() => {
                      setDeleteSubmitData({
                        ...deleteSubmitData,
                        id: item.id
                      });
                      setOpenDelete(true);
                    }}
                  >
                    <span className="icon-light-cancel" />
                    {t("table.delete")}
                  </button>
                </div>
              </StyledCol>
            </StyledTableRow>
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};
export default WalletWhitelistList;